<template>
  <div>
    <h2 class="text-lg leading-6 font-medium text-gray-900">
      {{ title }}
    </h2>
    <p v-if="description" class="mt-1 text-sm text-gray-500">
      {{ description }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Title',
    },
    description: {
      type: String,
      default: 'Description',
    },
  },
};
</script>
